<template>
  <div>
    <v-row>
      <v-col cols="12" md="12">
        <m-form
            :title="title"
            :showList="true"
            :cols="cols"
            @click:row="setItem"
            api-url="product/avail/all"
            :show-submit-and-clear-btn="false"
            :show-list-btn="false"
            :canDelete="item.id >= 1"
            :items="items"
            :canSubmit="canSubmit"
            :isEditing.sync="isEditing"
            :show-navigation-btns="false"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="AvailForm"
        >
          <template>
            <v-row>
              <v-col cols="12">
                <v-text-field label="* فایده "
                              v-model="item.name" background-color="white" class="rounded-lg"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12">
                <v-textarea label=" توضیحات "
                            v-model="item.explanation" background-color="white" class="rounded-lg"
                            :disabled="!isEditing" rows="3"/>
              </v-col>
            </v-row>
          </template>
        </m-form>

      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";


export default {
  name: "Currency",
  mixins: [MFormMixin,  formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      printUrl: 'product/avail/all',
      baseUrl: "product/avail",
      permissionBasename: "avail",
      appendSlash: false,
      hasList: false,
      no_edit_dialog: false,
      hasIdProp: true,
      show_setting: false,
      hasLock: false,
      error_dialog: false,
      error_message: null,
      isDefinable: false,
      myClass: '',
      ss: null,
      factors: [],
      PathLevels,
      VisitorLevels,
      paymentDialog: false,
      payment: '',
      performClearForm: true,
      items: [],
      first: false,
      cols: [
        {
          text: "فایده محصول",
          value: "name",
        },
        {
          text: "توضیحات",
          value: "explanation",
        },
      ],

    };
  },
  computed: {
    title(){
      return 'فایده محصول'
    },
    headers() {
      return [];
    },
  },
  updated() {
  },
  methods: {
  },
}
</script>

<style scoped lang="scss"></style>

